<template>
  <div class="settings-users-wrapper">
    <div id="settings-users-container">
      <ul
        id="settings-users-tabs"
        class="row tabs settings-users-tabs"
        data-tabs
      >
        <li
          v-if="isHkUserShow"
          class="tabs-title is-active column tab-size"
        >
          <a
            v-show="tabsCount > 1"
            href="#tab-hkl-user"
          >
            {{ $t('settings.hklUser') }}
          </a>
        </li>
        <li
          v-if="isVendorShow"
          class="tabs-title column tab-size"
          :class="{'is-active': !isHkUserShow && isVendorShow}"
        >
          <a
            v-show="tabsCount > 1"
            href="#tab-contractor"
          >
            {{ $t('settings.vendor') }}
          </a>
        </li>
        <li
          v-if="enableTenancyRecordsFeature && isTenancyUserShow"
          class="tabs-title column tab-size"
        >
          <a
            v-show="tabsCount > 1"
            href="#tab-tenant"
          >
            {{ $t('settings.tenancyUsers') }}
          </a>
        </li>
      </ul>

      <div
        data-tabs-content="settings-users-tabs"
        class="settings-tabs-content"
      >
        <div
          v-if="isHkUserShow"
          id="tab-hkl-user"
          class="tabs-panel is-active"
        >
          <div class="grey lighten-5">
            <HklUsers />
          </div>
        </div>
        <div
          v-if="isVendorShow"
          id="tab-contractor"
          class="tabs-panel"
          :class="{'is-active': !isHkUserShow && isVendorShow}"
        >
          <div class="grey lighten-5">
            <VendorAccounts />
          </div>
        </div>
        <div
          v-if="enableTenancyRecordsFeature && isTenancyUserShow"
          id="tab-tenant"
          class="tabs-panel"
        >
          <div class="grey lighten-5">
            <TenancyUsers />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HklUsers from '@/modules/settings/engineers/HKLUsers.vue'
import TenancyUsers from '@/modules/settings/tenants/TenancyUsers.vue'
import VendorAccounts from '@/modules/settings/vendors/VendorAccounts.vue'
import EventBus from '@/utils/eventBus'
import { aclHelper, aclPermsType } from '@/utils/aclHelper'

export default {
  name: 'EngineerUsers',
  components: {
    HklUsers,
    TenancyUsers,
    VendorAccounts,
  },
  computed: {
    ...mapGetters('regions', ['enableTenderFeature', 'enableProjectFeature', 'enableTenancyRecordsFeature']),
    isVendorShow () {
      return (this.enableTenderFeature || this.enableProjectFeature) &&
      [
        aclPermsType.settings.read,
        aclPermsType.departmentVendors.read,
        aclPermsType.vendorECircular.manageECircularContact,
        aclPermsType.settings.readVendors,
      ].some(perm => aclHelper.getAccess(perm))
    },
    isHkUserShow () {
      return aclHelper.getAccess(aclPermsType.settings.read)
    },
    isTenancyUserShow () {
      return aclHelper.getAccess(aclPermsType.settings.read)
    },
    tabsCount () {
      return [this.isHkUserShow, this.isVendorShow, this.isTenancyUserShow].filter(Boolean).length
    },
  },
  mounted () {
    if (!this.userSettingTabs) {
      this.userSettingTabs = new Foundation.Tabs($('#settings-users-tabs'))
    }
    EventBus.on('active-user-tab', (tabName) => {
      setTimeout(() => {
        $('#settings-users-tabs').foundation('selectTab', `#tab-${tabName}`, false)
      }, 100)
    })
  },
  destroyed () {
    if (this.userSettingTabs) {
      this.userSettingTabs.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings/style';
@import "~styles/tabsContainer";
.settings-users-wrapper {
  padding: 0 24px;
}
ul {
  border: none;
}
.row {
  max-width: 100%;
}
.tab-size {
  width: 33%;
}
</style>
